/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const TranslateIcon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 16, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="TranslateIcon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <g>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.7275 14H13.6846L13.0967 12H9.90332L9.31543 14H8.27246L10.626 6H12.374L14.7275 14ZM10.1973 11H12.8027L11.626 7H11.374L10.1973 11Z"
                fill="currentColor"
              />
              <path
                d="M6 2V3H9V4H7.74609C7.65292 4.36088 7.53389 4.71565 7.39062 5.06152C7.00554 5.99113 6.44903 6.83986 5.75 7.5625C6.23118 7.93015 6.7594 8.23405 7.32129 8.4668C7.58657 8.57668 7.85819 8.66984 8.13379 8.74609L7.86621 9.70996C7.55142 9.62284 7.24149 9.51614 6.93848 9.39062C6.24023 9.10138 5.58769 8.71564 5 8.24512C4.41231 8.71564 3.75977 9.10138 3.06152 9.39062C2.75851 9.51614 2.44858 9.62284 2.13379 9.70996L1.86621 8.74609C2.14181 8.66984 2.41343 8.57668 2.67871 8.4668C3.24059 8.23405 3.76882 7.93015 4.25 7.5625C3.72344 7.01802 3.27704 6.40041 2.9248 5.7334L3.80957 5.2666C4.12495 5.86379 4.52606 6.41562 5 6.89941C5.62635 6.26015 6.12413 5.50596 6.4668 4.67871C6.55891 4.45634 6.63949 4.2298 6.70801 4H1V3H5V2H6Z"
                fill="currentColor"
              />
            </g>
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

TranslateIcon.tags = [
  'translate',
  'language',
  'localization',
  'text',
  'conversion',
  'alphabet',
  'interpretation',
];

TranslateIcon.category = 'General Icons';

TranslateIcon.iconSize = 16;
